const array = {
	create: (length: number, fill: unknown = null) => Array.from({ length }, (_, i) => fill || i + 1 )
};

export default {
	array
};